import React, { Component } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";

import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import { API } from "aws-amplify";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PacmanLoader } from 'react-spinners';
import Moment from "moment";
import Select from 'react-select';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SaleSheetFollowUpQueue extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            agents: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            agentName: "",
            followUpDate: new Date(),
            selectedCityscope: null,
            cityscopeOptions:[],
            cityscope: null
        };

        
    }
    

    async componentDidMount() {
        console.log("In AgentList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        // try {
        //     const agents = await this.getAgents({scope: this.state.cityscope, agent: this.state.agentName, followupdate: this.state.followUpDate});
        //     this.setState({ agents });
        // } catch (e) {
        //     alert(e);
        // }
        this.getCityscopes();

        this.setState({ isLoading: false });     
        
        document.title = "Sale Sheet Follow Up";
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ agents: [] });        
    }


    
    async getAgents(filter) {
        console.log("Inside getAgents() ");
        
        return API.get("colin", "/queues/salesheets", { 'queryStringParameters': filter, 'cancelToken': source.token });
      
    }

    async getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }    

    addRecord = async event => {
        let agents = [...this.state.agents];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        agents.push({
            
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({agents});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/agents/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/agents/${record["cityscope"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let agents = [...this.state.agents];
        for (var i=0; i<agents.length; i++){
            const validation = this.validateRecord(agents[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (agents[i].hasOwnProperty("modified")) {
                    if (agents[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (agents[i].hasOwnProperty("new_record")) {
                                if (agents[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(agents[i]);
                            if (result.result) {
                                agents[i].modified = false;
                                if (agents[i].hasOwnProperty("new_record")) {
                                    if (agents[i].new_record === true) {

                                        agents[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    agents[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   

        // if (agents[0].hasOwnProperty("sort_order")) {
        //     agents.sort(function (a, b) { return a.sort_order - b.sort_order });
        // }
        
        this.setState({agents});

    }


    handleCityscopeChange = async (selectedCityscope) => {
        
        console.log(selectedCityscope);
        this.setState({ selectedCityscope
                        ,cityscope: selectedCityscope.map(r=>r.value).join(",")
                        , modified: true },this.handleBlur)
        

    }

    
    
    handleCheckboxChange = (cellInfo, event) => {
        let agents = [...this.state.agents];
        agents[cellInfo.index][cellInfo.column.id] = event.target.checked;
        agents[cellInfo.index].modified = true;
        this.setState({agents});
    };

    

    renderEditable = cellInfo => {
        const cellValue = this.state.agents[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        // onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    handleSubmit = async event =>{
        event.preventDefault();
        try {
            this.setState({isLoading: true});
            const agents = await this.getAgents({scope: this.state.cityscope, agent: this.state.agentName, followupdate: Moment(this.state.followUpDate).local().format()});
            this.setState({ agents });
            this.setState({isLoading: false});
        } catch (e) {
            alert(e);
        }
    }
    
    
    
      
    renderPacman(){
        return (
            <div className="outer-div"><div className='sweet-loading inner-div' >
                <PacmanLoader
                    css="display: block;
                    margin: 0 auto;
                     border-color: red"
                sizeUnit={"px"}
                size={20}
                color={'#e03c31'}
                loading={this.state.isLoading}
                />
        </div>
            </div>);
    }
    renderTable(data) {
        const columns = [
            {
                id: 'selected',
                Header: '',
                maxWidth: 60,
                accessor: 'selected',
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            },
            {
                id: 'entity_id_agent',
                Header: 'Entity ID',
                maxWidth: 150,
                accessor: 'entity_id_agent' ,
                Cell: e => <LinkContainer to={ {pathname: `/queues/salesheets/${e.value || 0}`, state: {followupdate: new Date(this.state.followUpDate).toISOString().slice(0,10), cityscope: this.state.cityscope , agentids: this.state.agents.filter((a) => { if(a.selected || a.entity_id_agent===e.value){return true;}else{return false;}} ).map(a => a.entity_id_agent)}}} ><a>{e.value || <i>(No Agent)</i>}</a></LinkContainer>
        }
        , {
                id: 'agent',
                Header: 'Agent',            
                accessor: 'agent',
                maxWidth: 250,
                Cell: e => <span>{ e.value || <i>(No Agent)</i> }</span>

            }, {
                id: 'telephone',
                Header: 'Telephone',            
                accessor: 'telephone',
                maxWidth: 150,
                Cell: e => <span>{ e.value || <i>(No Agent)</i> }</span>

            }
            ,
            
            {
                id: 'sale_sheet_count',
                Header: 'Sale Sheet Count',
                maxWidth: 150,
                accessor: 'sale_sheet_count'

            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={true}
                />
            )
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

 

    handleDateChange(date, name) {
        if (date) {
            this.setState({
                [name]: new Date(date)
                , modified: true });
        }
        else {
            this.setState({
                [name]: null
                , modified: true });
        }
        
    }

    selectAll = event =>{
        let agents = [...this.state.agents];
        for(var i=0;i<agents.length;i++){
            agents[i].selected=true;
        }
        this.setState({agents});
    }

    deselectAll = event =>{
        let agents = [...this.state.agents];
        for(var i=0;i<agents.length;i++){
            agents[i].selected=false;
        }
        this.setState({agents});
    }
    
    renderComponent() {
        return (
            <div className="agents">
                 
                <form onSubmit={this.handleSubmit}>
                 <Row >
                     <Col  sm={2} md={2} lg={2}>
                     <Form.Group controlId="cityscope" >
                        <Form.Label className="text-right" >Cityscope (leave blank for all)</Form.Label>

                        <Select
                            value={this.state.selectedCityscope}
                            onChange={this.handleCityscopeChange}
                            options={this.state.cityscopeOptions}
                            onInputChange={this.handleInputChange}
                            isMulti
                        />


                    </Form.Group>
                     </Col>
                 <Col sm={4} md={4} lg={3}>                    
                    <Form.Group  controlId="agentName" >
                        <Form.Label  >Agent Name</Form.Label>
                                <Form.Control
                                    onChange={this.handleChange}
                                    value={this.state.agentName}
                                    as="input"
                                    type="text"                                    
                            />
                    </Form.Group>
                    </Col > 
                    <Col sm={6} md={6} lg={3}> 
                    <Form.Group   controlId="followUpDate" >
                        <Form.Label>Follow Up Date Before</Form.Label><br/>
                            <DatePicker
                                selected={this.state.followUpDate}
                                onChange={e => this.handleDateChange(e, "followUpDate")}
                                name="followUpDate"
                                onBlur={this.handleSave}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                isClearable={true}
                            />
                    </Form.Group>

                        </Col>
                        <Col>
                        <Button type="submit" variant="primary">Search</Button>
                        </Col>
                    </Row> 
                    </form>
                    <Row><Col className="text-left" >
                <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>Select All</Button>{" "}
                <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>Deselect All</Button>{" "}
                
                </Col></Row>
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.agents) : this.renderPacman() }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="AgentList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
